import configHolidayService from "@services/configHoliday/configHolidayService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import { action, makeAutoObservable, observable } from "mobx"

class ConfigHolidayStore {
  @observable isLoading!: boolean
  @observable listWorkDay: any = []
  @observable dataTableHoliday!: PagedResultDto<any>

  constructor() {
    makeAutoObservable(this)
    // this.getDepartments({});

    this.dataTableHoliday = { items: [], totalCount: 0 }
    this.listWorkDay = []
  }

  // Work Day
  @action async getListWorkDay(params?) {
    this.isLoading = true
    const result = await configHolidayService
      .getListWorkDay(params)
      .finally(() => (this.isLoading = false))

    this.listWorkDay = result || []
  }

  @action async changeConfigWorkday(body) {
    this.isLoading = true
    await configHolidayService
      .changeConfigWorkday(body)
      .finally(() => (this.isLoading = false))
  }

  @action async getAllHoliday(params?) {
    this.isLoading = true
    const result = await configHolidayService
      .getAllHoliday(params)
      .finally(() => (this.isLoading = false))

    this.dataTableHoliday = result || []
  }

  @action async createOrUpdate(body) {
    this.isLoading = true
    await configHolidayService
      .createOrUpdate(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  async activate(id: number, isActive) {
    await configHolidayService.activate(id, isActive)
  }
}

export default ConfigHolidayStore
